import { useState } from 'react';
import getResultsOne from '../../Components/AppVocationOne/API/getResults';

const DataParserPage = () => {
  const [oneData, setOneData] = useState('');
  const [result, setResult] = useState(null);

  const handleParseOneData = () => {
    const parsed = typeof oneData === 'string' ? JSON.parse(oneData) : oneData;
    console.log({ parsed });
    const resultData = getResultsOne(parsed);
    console.log({ resultData });
    setResult(resultData);
  };
  return (
    <div>
      <div>
        <h1>Data Results parser</h1>
      </div>
      <div>
        <h2>Voc One</h2>
        <div>
          <textarea
            value={oneData}
            onChange={e => setOneData(e.target.value)}
            cols={20}
            style={{ width: '80vw' }}
          />
        </div>
        <div>
          <button onClick={handleParseOneData}>Generar data</button>
        </div>
      </div>
      <h2>Result</h2>
      <div>
        <pre>{result && JSON.stringify(result, null, 2)}</pre>
      </div>
    </div>
  );
};

export default DataParserPage;
